import {PluginCommand as command_instrument} from "../src/commands/instrument"
import {PluginCommand as command_uninstrument} from "../src/commands/uninstrument"

export const commands = {
  "instrument": {PluginCommand: command_instrument},
  "uninstrument": {PluginCommand: command_uninstrument},
}